import { Pipe, type PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { RoomType } from '../models';

@Pipe({ name: 'roomType' })
export class RoomTypePipe implements PipeTransform {
    constructor(private translateService: TranslateService) {}

    transform(roomType: RoomType): string {
        if (!roomType) {
            return '';
        }

        const translationKey = `RBR.ROOM_TYPE.${roomType}`;

        return this.translateService.instant(translationKey);
    }
}
